export const CART_STORAGE_VERSION = 1;
export const DEFAULT_SHIPPING_PRICE = 4.95;

export function createCartItemId(productId) {
  const prefix = productId || "item";

  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return `${prefix}_${crypto.randomUUID()}`;
  }

  return `${prefix}_${Date.now()}_${Math.random().toString(16).slice(2)}`;
}

export function normalizeCartItem(item) {
  const quantity = Number(item.quantity) || 1;
  const unitPrice = Number(item.unitPrice) || 0;

  return {
    cartItemId: item.cartItemId || createCartItemId(item.productId),
    productId: item.productId,
    productName: item.productName || "",
    category: item.category || "",
    type: item.type || "",
    quantity,
    unitPrice,
    subtotalPrice: Number((unitPrice * quantity).toFixed(2)),
    currency: item.currency || "EUR",
    options: item.options || {},
    assets: item.assets || [],
    editorState: item.editorState || null,
    tempFiles: item.tempFiles || [],
    notes: item.notes || [],
    promotion: item.promotion || null,
  };
}

export function calculateCartTotals(items, shippingPrice = 0) {
  const subtotalPrice = items.reduce((total, item) => {
    return total + (Number(item.subtotalPrice) || 0);
  }, 0);

  const totalQuantity = items.reduce((total, item) => {
    return total + (Number(item.quantity) || 0);
  }, 0);

  const appliedShippingPrice = hasCartItems(items)
    ? Number(shippingPrice.toFixed(2))
    : 0;

  return {
    itemCount: items.length,
    totalQuantity,
    subtotalPrice: Number(subtotalPrice.toFixed(2)),
    shippingPrice: appliedShippingPrice,
    totalPrice: Number((subtotalPrice + appliedShippingPrice).toFixed(2)),
  };
}

export function hasCartItems(items) {
  return Array.isArray(items) && items.length > 0;
}
